import { Stack, Text, Link } from "@chakra-ui/react";
import { SafePlasmicComponent } from "~/components/plasmic/SafePlasmicComponent";

export function RekaFAQ() {
  return (
    <Stack pt="20" pb="8" gap="4">
      <Text size={{ mobile: 'sm', desktop: 'md' }} fontWeight="light" color="blackAlpha.900">
        Information
      </Text>
      <SafePlasmicComponent component="RekaFAQ" />
      <Link href="/p/reka-bostad-faq" mt="4">
        Visa alla
      </Link>
    </Stack>
  );
}
